export function capitalize(value: string): string {
  if (!value) {
    return value;
  }

  return String(value).charAt(0).toUpperCase() + String(value).slice(1);
}
